import React, { Component, Fragment } from "react"
// import { profilePic } from '../../assets/images/pro1.jpg';
// import { Grid, Image } from 'semantic-ui-react'
import { SystemServices, UtilityService } from "../../services"
import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"
import Pagination from "react-js-pagination"
import AlertContainer from "react-alert"
import leftArrowImage from "../../assets/images/left-arrow.png"
import Button from "../../components/Buttons/Button"
import { connect } from "react-redux"
import sampleService from "../../services/sample.service"

class SystemCategoryList extends Component {
  state = {
    activePage: 1,
    queryUrl: [],
    count: 0,
    wastage: "",
    otherSize: "",
    wash: "",
    usd: "",
    gbp: "",
    eur: "",
    gst: "",
    valueLoss: "",
    overHeads: "",
    conversionRate: "",
    freightCharges: "",
    processingCost: "",
    price: "",
    duty: "",
    orderQty: "",
    noOftailors: null,
    listHide: false,
    _id: "",
    componentLoaded: false,
    supplierPartFabric: {
      gst: null,
      transport: null,
      freight: null,
      clearance: null,
      duty: null,
      conversion: null
    },
    supplierPartTrim: {
      gst: null,
      transport: null,
      freight: null,
      clearance: null,
      duty: null,
      conversion: null
    },
    smockingorElastic: {},
    toptthElastic: {}
  }
  alertOptions = {
    offset: 65,
    position: "top left",
    theme: "dark",
    time: 1000,
    transition: "scale"
  }

  componentWillMount() {
    this.setSystemCategoryList()
  }

  componentDidMount() { }

  setSystemCategoryList = () => {
    let subModuleName = this.props.location.search
    let fullValue = [
      this.props.location.pathname.slice(1),
      ...subModuleName.split("?").slice(1)
    ]
    this.setState({
      queryUrl: [...fullValue]
    })

    this.setState({
      categoryHeading:
        fullValue[0] === "EMBROIDERY&EMBELISHMENT"
          ? "EMBROIDERY/EMBELISHMENT"
          : fullValue[0] === "GREIGE&DENIM"
            ? "GREIGE/DENIM"
            : fullValue[0],
      categoryValue: fullValue[2],
      componentMounted: true
    })
    if (fullValue[1] === "TRIM" && fullValue[2] === "SHIRRING_OR_SMOCKING") {
      SystemServices.getCategoryForSmockingSheering().then(res => {
        const smokingSheeringObject = { ...this.state.smokingSheeringObject }

        smokingSheeringObject.smockingorElastic = res.data.data.smockingorElastic
        smokingSheeringObject.toptthElastic = res.data.data.toptthElastic

        this.setState({
          ...smokingSheeringObject
        })
      })
    }

    if (fullValue[1] === "SUPPLIER" && fullValue[2] === 'SUPPLIER_PART') {
      if (fullValue[0] === 'fabric') {
        SystemServices.getSupplierPart('Fabrics').then(res => {
          if (res.message === "Operation Successful") {
            this.setState({
              _id: res.data._id,
              supplierPartFabric: {
                gst: res.data.gst,
                conversion: res.data.conversion,
                duty: res.data.duty,
                freight: res.data.freight,
                transport: res.data.transport,
                clearance: res.data.clearance
              }
            })
          }
        })

      } else if (fullValue[0] === 'trims') {
        SystemServices.getSupplierPart('Trims').then(res => {
          if (res.message === "Operation Successful") {
            this.setState({
              _id: res.data._id,
              supplierPartTrim: {
                gst: res.data.gst,
                conversion: res.data.conversion,
                duty: res.data.duty,
                freight: res.data.freight,
                transport: res.data.transport,
                clearance: res.data.clearance
              }
            })
          }
        })
      }
    }

    if (fullValue[1] === "EMBROIDERY&EMBELISHMENT") {
      SystemServices.listCategoryContent(
        fullValue[2]
          .split("_")
          .join("")
          .toLocaleUpperCase(),
        "EMBROIDERY/EMBELISHMENT",
        fullValue[0] + "s",
        this.state.activePage
      )
        .then(response => {
          if (response.message === "Operation Successful") {
            this.setState({
              categoryDataList: response.data.sysData,
              count: response.data.count,
              componentMounted: true
            })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else if (fullValue[1] === "GREIGE&DENIM") {
      SystemServices.listCategoryContent(
        fullValue[2]
          .split("_")
          .join("")
          .toLocaleUpperCase(),
        "GREIGE/DENIM",
        fullValue[0] + "s",
        this.state.activePage
      )
        .then(response => {
          if (response.message === "Operation Successful") {
            this.setState({
              categoryDataList: response.data.sysData,
              count: response.data.count,
              componentMounted: true
            })
          }
        })
        .catch(error => {
          this.props.getalertMessage("error", error.toString())
        })
    } else if (fullValue[1] === "GREIGE&DENIM") {
      SystemServices.listCategoryContent(
        fullValue[2]
          .split("_")
          .join("")
          .toLocaleUpperCase(),
        "GREIGE/DENIM",
        fullValue[0] + "s",
        this.state.activePage
      )
        .then(response => {
          if (response.message === "Operation Successful") {
            this.setState({
              categoryDataList: response.data.sysData,
              count: response.data.count,
              componentMounted: true
            })
          }
        })
        .catch(error => {
          this.props.getalertMessage("error", error.toString())
        })
    } else if (
      fullValue[1] === "SMV&THREADCONSUMPTION" &&
      fullValue[2] === "OTHERS"
    ) {
      SystemServices.getSmvOthers()
        .then(response => {
          if (response.status === 200) {
            if (response.text.data !== null) {
              this.setState({
                wastage: response.text.data.wastage,
                wash: response.text.data.wash,
                otherSize: response.text.data.otherSize,
                _id: response.text.data._id,
                componentMounted: true
              })
            }
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))

      this.setState({
        listHide: true
      })
    } else if (
      fullValue[1] == "COSTING" &&
      fullValue[2] == "CURRENCY_CONVERSION"
    ) {
      SystemServices.getcurrencyConversion()
        .then(response => {
          if (response.status === 200) {
            if (response.text.data !== null) {
              this.setState({
                usd: response.text.data.usd,
                gbp: response.text.data.gbp,
                eur: response.text.data.eur,
                _id: response.text.data._id,
                componentMounted: true
              })
            }
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))

      this.setState({
        listHide: true
      })
    }else if(fullValue[1] == "FABRIC" && fullValue[2]== "GST"){
      SystemServices.getGstValue()
        .then(response => {
          if(response.status === 200){
            if(response.text.data !== null){
              this.setState({
                gst: response.text.data.gst,
                componentMounted: true
              })
            }
          }
        })
      this.setState({
        listHide: true
      })
    
    } else if (fullValue[1] == "COSTING" && fullValue[2] == "OTHERS") {
      SystemServices.getCostingOthers()
        .then(response => {
          if (response.status === 200) {
            if (response.text.data !== null) {
              this.setState({
                valueLoss: response.text.data.valueLoss,
                overHeads: response.text.data.overHeads,
                conversionRate: response.text.data.conversionRate,
                freightCharges: response.text.data.freightCharges,
                processingCost: response.text.data.processingCost,
                duty: response.text.data.duty,
                orderQty: response.text.data.orderQty,
                noOftailors: response.text.data.noOftailors,
                costPertailor: response.text.data.costPertailor,
                perMachine: response.text.data.perMachine,
                idleDays: response.text.data.idleDays,
                _id: response.text.data._id,
                componentMounted: true
              })
            }
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))

      this.setState({
        listHide: true
      })
    } else {
      if (
        fullValue[2] === "SHIPMENT_TERM" ||
        fullValue[2] === "SHIPMENT_MODE" ||
        fullValue[2] === "PORT_OF_PICK_UP" ||
        fullValue[2] === "FABRIC_HSN"
      ) {
        SystemServices.listCategoryContent(
          fullValue[2]
            .split("_")
            .join("")
            .toLocaleUpperCase(),
          fullValue[1]
            .split("_")
            .join(" ")
            .toLocaleUpperCase(),
          fullValue[0] === "trims" ? fullValue[0] : fullValue[0] + "s",
          this.state.activePage
        )
          .then(response => {
            if (response.message === "Operation Successful") {
              this.setState({
                categoryDataList: response.data.sysData,
                count: response.data.count,
                componentMounted: true
              })
            }
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
      } else {
        SystemServices.listCategoryContent(
          fullValue[2]
            .split("_")
            .join("")
            .toLocaleUpperCase(),
          fullValue[1]
            .split("_")
            .join("")
            .toLocaleUpperCase(),
          fullValue[0] === "trims" ? fullValue[0] : fullValue[0] + "s",
          this.state.activePage
        )
          .then(response => {

            if (response.message === "Operation Successful") {
              this.setState({
                categoryDataList: response.data.sysData,
                count: response.data.count,
                componentMounted: true
              })
            }
          })
          .catch(error => {
            this.props.getalertMessage("error", error.toString())
          })
      }
    }
  }

  pageNavigate = value => {
    this.props.history.push(
      `/${value}?${this.props.location.pathname.slice(
        1
      )}?${this.props.location.search.slice(1)}`
    )
  }

  pageAction = (value, id, categoryValue, category) => {
    if (this.state.categoryValue === "FINISH(FEEL)") {
      this.props.history.push(
        `/${value}?${id}?${this.props.location.pathname.slice(1)}?${"FINISH"}`
      )
    } else {
      this.props.history.push(
        `/${value}?${id}?${this.props.location.pathname.slice(
          1
        )}?${this.props.location.search.slice(1)}`
      )
    }
  }

  pageChangeForCity = (
    value,
    id,
    categoryValue,
    country,
    countryId,
    category
  ) => {
    let categoryData = {
      categoryName: categoryValue,
      country: country,
      countryId: countryId,
      categoryFull: category
    }
    this.props.history.push(
      `/${value}?${id}?${this.props.location.pathname.slice(
        1
      )}?${this.props.location.search.slice(1)}`
    )
  }

  submit = id => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to delete this file?</p>
            <button type="button" class="primary" onClick={onClose}>
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              onClick={() => {
                this.removeCategory(id)
                onClose()
              }}
            >
              Yes, Delete it!
            </button>
          </div>
        )
      }
    })
  }

  removeCategory = id => {
    SystemServices.removeSystemCategory(
      id,
      this.state.categoryHeading
        .split("_")
        .join("")
        .toLocaleUpperCase()
    )
      .then(response => {
        if (response.message === "Successfully deleted") {
          SystemServices.listCategoryContent(
            this.state.queryUrl[2]
              .split("_")
              .join("")
              .toLocaleUpperCase(),
            this.state.queryUrl[1]
              .split("_")
              .join("")
              .toLocaleUpperCase(),
            this.state.queryUrl[0] === "trims"
              ? this.state.queryUrl[0]
              : this.state.queryUrl[0] + "s",
            this.state.activePage
          )
            .then(response => {
              if (response.message === "Operation Successful") {
                this.setState({
                  categoryDataList: response.data.sysData,
                  count: response.data.count
                })
                UtilityService.deleteMsg(this.msg)
              }
            })
            .catch(error => {
              this.props.getalertMessage("error", error.toString())
            })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  handlePageChange = pageNumber => {
    this.setState({ activePage: pageNumber }, () => {
      this.setSystemCategoryList()
    })
  }

  updateValue = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  sheeringSmookingtoptthElastic = (name, value) => {

    const toptthElastic = { ...this.state.toptthElastic }

    toptthElastic[name] = value

    this.setState({
      toptthElastic
    })
  }

  sheeringSmookingsmockingorElastic = (name, value) => {

    const smockingorElastic = { ...this.state.smockingorElastic }
    smockingorElastic[name] = value

    this.setState({
      smockingorElastic
    })
  }

  sheeringSmookingSubmit = () => {
    const { smockingorElastic, toptthElastic } = this.state
    const value = {
      smockingorElastic: smockingorElastic,
      toptthElastic: toptthElastic,

    }

    SystemServices.addCategoryForSmockingSheering({ ...value }).then(res => {
      if (res.message === 'Success') {
        this.props.getalertMessage("success", res.message)
      }
    })
  }

  smvOthers = () => {
    SystemServices.smvOthers(
      this.state.queryUrl[1],
      this.state.queryUrl[2],
      this.state.wastage,
      this.state.otherSize,
      this.state.wash,
      this.state._id
    )
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage(error.toString()))
  }

  currencyConversion = () => {
    SystemServices.currencyConversion(
      this.state.queryUrl[1],
      this.state.queryUrl[2],
      this.state.usd,
      this.state.gbp,
      this.state.eur,
      this.state._id
    )
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage(error.toString()))
  }

  editGstValue = () => {
    SystemServices.editGstValue(
      this.state.gst,
    )
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage(error.toString()))
  }

  generalSupplierPart = (queryUrl) => {


    // const {
    //   clearance,
    //   conversion,
    //   duty,
    //   freight,
    //   gst,
    //   transport
    // } = supplierPart

    if (queryUrl === 'fabric') {
      const supplierPartFabric = { ...this.state.supplierPartFabric }
      SystemServices.addCategory(
        "dummy",
        "SUPPLIERPART",
        "SUPPLIER",
        "Fabrics",
        null,
        supplierPartFabric,
        this.state._id,
        'Fabrics'
      ).then(response => {
        this.props.getalertMessage("success", response.message)
      })
    } else if (queryUrl === 'trims') {

      const supplierPartTrim = { ...this.state.supplierPartTrim }
      SystemServices.addCategory(
        "dummy",
        "SUPPLIERPART",
        "SUPPLIER",
        "Trims",
        null,
        supplierPartTrim,
        this.state._id,
        'Trims'
      ).then(response => {
        this.props.getalertMessage("success", response.message)
      })
    }
  }

  updateValueSupplier = (name, value, queryUrl) => {

    if (queryUrl === 'fabric') {
      const supplierPartFabric = { ...this.state.supplierPartFabric }
      supplierPartFabric[name] = value
      this.setState({
        supplierPartFabric
      })
    } else if (queryUrl === 'trims') {
      const supplierPartTrim = { ...this.state.supplierPartTrim }
      supplierPartTrim[name] = value
      this.setState({
        supplierPartTrim
      })
    }
  }

  costingOthers = () => {
    SystemServices.costingOthers(
      this.state.queryUrl[1],
      this.state.queryUrl[2],
      this.state.valueLoss,
      this.state.overHeads,
      this.state.conversionRate,
      this.state.freightCharges,
      this.state.processingCost,
      this.state.duty,
      this.state.orderQty,
      this.state.costPertailor,
      this.state.noOftailors,
      this.state.perMachine,
      this.state.idleDays,
      this.state._id
    )
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage(error.toString()))
  }

  preventSpecialChars = (e) => {
    const invalidChars = ['-', '+', 'e', 'E', '.']; 
    if (invalidChars.includes(e.key)) {
      e.preventDefault(); // Prevent these characters from being entered
    }
  };
  

  render() {
    return (
      <Fragment>
        <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
        <div class="right-section bg-white">
          <div class="row nopadding">
            <div class="col-md-12 text-center p-2">
              <ul className="list-inline">
                <li className="pull-left">
                  <span
                    className="p-2 cursor-hover"
                    onClick={e => this.props.history.goBack()}
                  >
                    <img width={"20px"} src={leftArrowImage} />
                  </span>
                </li>
                <li>
                  <h6>{this.state.queryUrl[2].split("_").join(" ")}</h6>
                </li>
                {this.props.rights.create &&
                  this.state.categoryValue != "SHIRRING_OR_SMOCKING" && (
                    <li class="pull-right" style={{ cursor: "pointer" }}>
                      {this.state.categoryDataList &&
                        this.state.categoryDataList.length > 0 &&
                        (this.state.categoryValue === "ASSIGNED_TO" ||
                          this.state.categoryValue === "BOTH_ELASTIC" ||
                          this.state.categoryValue ===
                          "TOP_TTH_OR_BOTTOM_ELASTIC") ? (
                        ""
                      ) : this.state.listHide ? null : this.state
                        .componentMounted === true ? (
                        this.state.categoryValue === "DURATION" ? (
                          this.state.categoryDataList !== undefined ? (
                            this.state.categoryDataList.length < 1 ? (
                              <button
                                className="primary"
                                onClick={() => this.pageNavigate("add")}
                              >
                                {" "}
                                Add New
                              </button>
                            ) : null
                          ) : null
                        ) : (
                          <button
                            className="primary"
                            onClick={() => this.pageNavigate("add")}
                          >
                            {" "}
                            Add New
                          </button>
                        )
                      ) : (
                        <button
                          className="primary"
                          onClick={() => this.pageNavigate("add")}
                        >
                          {" "}
                          Add New
                        </button>
                      )}
                    </li>
                  )}
              </ul>
            </div>
            {this.state.queryUrl[1] == "SMV&THREADCONSUMPTION" &&
              this.state.categoryValue == "OTHERS" ? (
              <div className="col-md-6 col-md-offset-5 small-input">
                <div className="form-group">
                  <label>Wastage</label>
                  <input
                    type="text"
                    size="4"
                    value={this.state.wastage}
                    className="form-control"
                    onChange={e => this.updateValue("wastage", e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>Other Sizes</label>
                  <input
                    type="text"
                    size="4"
                    value={this.state.otherSize}
                    className="form-control"
                    onChange={e =>
                      this.updateValue("otherSize", e.target.value)
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Wash</label>
                  <input
                    type="text"
                    size="4"
                    value={this.state.wash}
                    className="form-control"
                    onChange={e => this.updateValue("wash", e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <Button buttonName={"save"} onClick={this.smvOthers} />
                  <Button
                    buttonType={"cancel"}
                    buttonName={"cancel"}
                    history={this.props.history}
                  />
                </div>
              </div>
            ) : this.state.queryUrl[1] == "COSTING" &&
              this.state.categoryValue == "CURRENCY_CONVERSION" ? (
              <div className="col-md-6 col-md-offset-5 small-input">
                <div className="form-group">
                  <label>USD</label>
                  <input
                    type="number"
                    size="4"
                    value={this.state.usd}
                    className="form-control"
                    onChange={e => this.updateValue("usd", e.target.value)}
                    onKeyDown={this.preventSpecialChars}
                  />
                </div>
                <div className="form-group">
                  <label>GBP</label>
                  <input
                    type="number"
                    size="4"
                    value={this.state.gbp}
                    className="form-control"
                    onChange={e => this.updateValue("gbp", e.target.value)}
                    onKeyDown={this.preventSpecialChars}
                  />
                </div>
                <div className="form-group">
                  <label>EUR</label>
                  <input
                    type="number"
                    size="4"
                    value={this.state.eur}
                    className="form-control"
                    onChange={e => this.updateValue("eur", e.target.value)}
                    onKeyDown={this.preventSpecialChars} // Prevent special characters
                  />
                </div>
                <div className="form-group">
                  <Button
                    buttonName={"save"}
                    onClick={this.currencyConversion}
                  />
                  <Button
                    buttonType={"cancel"}
                    buttonName={"cancel"}
                    history={this.props.history}
                  />
                </div>
              </div>
            ) : this.state.queryUrl[1] == "COSTING" &&
              this.state.categoryValue == "OTHERS" ? (
              <div className="col-md-12 d-flex flex-column align-items-center medium-input">
                <div>
                  <div className="col-12">
                    <tr>
                      <td>COST SHEET</td>
                    </tr>
                    <tr className="form-group">
                      <td>
                        <label>Value Loss</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.valueLoss}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("valueLoss", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr className="form-group">
                      <td>
                        <label>Contribution % </label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.overHeads}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("overHeads", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>LANDED CALCULATION WORKING</td>
                    </tr>
                    <tr className="form-group">
                      <td>
                        <label>Conversion Rate</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.conversionRate}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("conversionRate", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Freight Charges</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.freightCharges}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("freightCharges", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Processing Cost</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.processingCost}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("processingCost", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Duty</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.duty}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("duty", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>SMV CALCULATION WORKING </td>
                    </tr>
                    <tr>
                      <td>
                        <label>SMV Order Qty</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.orderQty}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("orderQty", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>No of TAILORS</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.noOftailors}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("noOftailors", e.target.value)
                          }
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label>Cost Per Tailor</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.costPertailor}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("costPertailor", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Per Machine Cost</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.perMachine}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("perMachine", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Idle Days</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={this.state.idleDays}
                          className="form-control"
                          onChange={e =>
                            this.updateValue("idleDays", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  </div>
                </div>
                <div className="form-group text-center">
                  <Button buttonName={"save"} onClick={this.costingOthers} />
                  <Button
                    buttonType={"cancel"}
                    buttonName={"cancel"}
                    history={this.props.history}
                  />
                </div>
              </div>
            ) :this.state.queryUrl[1] == "FABRIC" &&
            this.state.categoryValue == "GST" ? (
            <div className="col-md-6 col-md-offset-5 small-input">
              <div className="form-group">
                <label>GST</label>
                <input
                  type="number"
                  size="4"
                  value={this.state.gst}
                  className="form-control"
                  onChange={e => this.updateValue("gst", e.target.value)}
                  onKeyDown={this.preventSpecialChars}
                />
              </div>
              <div className="form-group">
                  <Button
                    buttonName={"save"}
                    onClick={this.editGstValue}
                  />
                  <Button
                    buttonType={"cancel"}
                    buttonName={"cancel"}
                    history={this.props.history}
                  />
                </div>
              </div>
              ): this.state.queryUrl[1] == "SUPPLIER" &&
              this.state.categoryValue == "SUPPLIER_PART" ? (
              <div className="col-md-12 d-flex flex-column align-items-center medium-input">
                <div>
                  <div className="col-12">
                    <tr>
                      <td>DEVELOPMENT {this.state.queryUrl[0].toUpperCase()} - SUPPLIER PART</td>
                    </tr>
                    <tr className="form-group">
                      <td>
                        <label>GST %</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={Number(this.state.supplierPartFabric.gst) || Number(this.state.supplierPartTrim.gst)}
                          className="form-control"
                          onChange={e =>
                            this.updateValueSupplier("gst", e.target.value, this.state.queryUrl[0].toLowerCase())
                          }
                        />
                      </td>
                    </tr>
                    <tr className="form-group">
                      <td>
                        <label>Transport ₹</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={Number(this.state.supplierPartFabric.transport) || Number(this.state.supplierPartTrim.transport)}
                          className="form-control"
                          onChange={e =>
                            this.updateValueSupplier(
                              "transport",
                              e.target.value, this.state.queryUrl[0].toLowerCase()
                            )
                          }
                        />
                      </td>
                    </tr>
                    <tr className="form-group">
                      <td>
                        <label>Freight ₹</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={Number(this.state.supplierPartFabric.freight) || Number(this.state.supplierPartTrim.freight)}
                          className="form-control"
                          onChange={e =>
                            this.updateValueSupplier("freight", e.target.value, this.state.queryUrl[0].toLowerCase())
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Clearance ₹</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={Number(this.state.supplierPartFabric.clearance) || Number(this.state.supplierPartTrim.clearance)}
                          className="form-control"
                          onChange={e =>
                            this.updateValueSupplier(
                              "clearance",
                              e.target.value, this.state.queryUrl[0].toLowerCase()
                            )
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Duty %</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={Number(this.state.supplierPartFabric.duty) || Number(this.state.supplierPartTrim.duty)}
                          className="form-control"
                          onChange={e =>
                            this.updateValueSupplier("duty", e.target.value, this.state.queryUrl[0].toLowerCase())
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Conversion Rate - $ to ₹</label>
                      </td>
                      <td>
                        <input
                          type="number"
                          size="4"
                          width=""
                          value={Number(this.state.supplierPartFabric.conversion) || Number(this.state.supplierPartTrim.conversion)}
                          className="form-control"
                          onChange={e =>
                            this.updateValueSupplier(
                              "conversion",
                              e.target.value, this.state.queryUrl[0].toLowerCase()
                            )
                          }
                        />
                      </td>
                    </tr>
                  </div>
                </div>
                <div className="form-group text-center">
                  <Button
                    buttonName={"save"}
                    onClick={() => this.generalSupplierPart(this.state.queryUrl[0].toLowerCase())}
                  />
                  <Button
                    buttonType={"cancel"}
                    buttonName={"cancel"}
                    history={this.props.history}
                  />
                </div>
              </div>
            ) : (
              <div class="col-md-12 nopadding">
                <div class="card-container cust-card-con">
                  <div class="table-container">
                    <table class="striped list-table">
                      <thead>
                        <tr>
                          {this.state.categoryValue === "CITY" ? (
                            <Fragment>
                              <th data-field="id">COUNTRY Name</th>
                              <th data-field="id"> CITY Name</th>
                            </Fragment>
                          ) : this.state.categoryValue === "ADDRESS" ? (
                            <Fragment>
                              <th data-field="id">COUNTRY Name</th>
                              <th data-field="id"> CITY Name</th>
                              <th data-field="id"> ADDRESS</th>
                            </Fragment>
                          ) : this.state.categoryValue === "MACHINE" ? (
                            <Fragment>
                              <th data-field="id">MACHINE Code (M/C)</th>
                              <th data-field="id">Needle Code </th>
                              <th data-field="id">Rating </th>
                              <th data-field="id">Needle %</th>
                              <th data-field="id">Looper %</th>
                              <th data-field="id">Over Lock % (O/L)</th>
                              <th data-field="id">Trim Threading % (TRD)</th>
                              <th data-field="id">Shirring Needle %</th>
                            </Fragment>
                          ) : this.state.categoryValue ===
                            "SHIRRING_OR_SMOCKING" ? (
                            <Fragment>
                              <th data-field="id"></th>
                              <th data-field="id">MULTIPLE</th>
                              <th data-field="id">WASTAGE</th>
                            </Fragment>
                          ) :
                            this.state.categoryValue ===
                              "TAILORS_NAME" ? (
                              <Fragment>
                                <th data-field="id">Name</th>
                                <th data-field="id">Number</th>
                              </Fragment>
                            ) :
                            (this.state.categoryValue === "VALUE_LOSS" || this.state.categoryValue === "DYING/PRINT" || this.state.categoryValue === "UPCHARGE") ? (
                                <th data-field="id">
                                {this.state.categoryValue.split("_").join(" ")}{" "}
                                </th>
                              ) : (
                              <th data-field="id">
                                {this.state.categoryValue.split("_").join(" ")}{" "}
                                Name
                              </th>
                            )}
                          {(this.state.categoryValue === "WASH_TYPE" ||
                            this.state.categoryValue === "EMB_FORM") && (
                              <th data-field="id">Price</th>
                            )}
                          {this.state.categoryValue != "SHIRRING_OR_SMOCKING" && (
                            <th colspan="3" data-field="price">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {(this.state.categoryValue === "SHIRRING_OR_SMOCKING" && (
                          <Fragment>
                            <tr>
                              <th width="25%">SMOCKING OR BOTH ELASTIC</th>
                              <td>
                                <input
                                  type="number"
                                  id=""
                                  value={this.state.smockingorElastic.multiple}
                                  name="multiple"
                                  placeholder=""
                                  onChange={(e) => this.sheeringSmookingsmockingorElastic('multiple', e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  id=""
                                  value={this.state.smockingorElastic.wastage}
                                  name="wastage"
                                  placeholder=""
                                  onChange={(e) => this.sheeringSmookingsmockingorElastic('wastage', e.target.value)}
                                /><p className="d-inline p-0 font-weight-bold">%</p>
                              </td>
                            </tr>
                            <tr>
                              <th width="25%">TOP TTH / BOTTOM ELASTIC</th>
                              <td>
                                <input
                                  type="number"
                                  id=""
                                  value={this.state.toptthElastic.multiple}
                                  name="multiple"
                                  placeholder=""
                                  onChange={(e) => this.sheeringSmookingtoptthElastic('multiple', e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  id=""
                                  value={this.state.toptthElastic.wastage}
                                  name="wastage"
                                  placeholder=""
                                  onChange={(e) => this.sheeringSmookingtoptthElastic('wastage', e.target.value)}
                                /><p className="d-inline p-0 font-weight-bold">%</p>
                              </td>
                            </tr>
                            <tr style={{ width: "100%" }}>
                              <td></td>
                              <td>
                                <button
                                  className="primary"
                                  onClick={() => {
                                    this.sheeringSmookingSubmit()
                                  }}
                                >
                                  Update
                                </button>{" "}
                              </td>
                              <td></td>
                            </tr>
                          </Fragment>
                        )) ||
                          (this.state.categoryDataList !== undefined &&
                            Array.isArray(this.state.categoryDataList) &&
                            this.state.categoryDataList.map(
                              (category, index) => (
                                <tr>
                                  {this.state.categoryValue === "CITY" && (
                                    <Fragment>
                                      <td>
                                        {(category.country &&
                                          category.country.name) ||
                                          ""}
                                      </td>
                                    </Fragment>
                                  )}
                                  {this.state.categoryValue === "ADDRESS" &&
                                    category.city !== undefined &&
                                    category.country !== undefined && (
                                      <Fragment>
                                        <td>{category.country.name}</td>
                                        <td>{category.city.name}</td>
                                      </Fragment>
                                    )}
                                  <td>{category.name}</td>
                                  {(this.state.categoryValue === "WASH_TYPE" ||
                                    this.state.categoryValue ===
                                    "EMB_FORM") && <td>{category.price}</td>}
                                  {this.state.categoryValue === "MACHINE" && (
                                    <Fragment>
                                      <td>{category.needleCode}</td>
                                      <td>{category.factor}</td>
                                      <td>{category.needle + "%"}</td>
                                      <td>{category.looper + "%"}</td>
                                      <td>{category.overLock + "%"}</td>
                                      <td>{category.trimThread + "%"}</td>
                                      <td>{category.sheeringNeedle + "%"}</td>
                                    </Fragment>
                                  )}
                                  {(this.state.categoryValue === "TAILORS_NAME") && <td>{category.number}</td>}
                                  <td>
                                    <span
                                      class="view cursor-hover"
                                      title="view"
                                      onClick={() =>
                                        this.state.categoryValue === "CITY" ||
                                          this.state.categoryValue === "ADDRESS"
                                          ? this.pageChangeForCity(
                                            "view",
                                            category._id,
                                            category.name,
                                            category.country.name,
                                            category.country._id,
                                            category
                                          )
                                          : this.pageAction(
                                            "view",
                                            category._id,
                                            category.name,
                                            category
                                          )
                                      }
                                    >
                                      <i class="material-icons">visibility</i>
                                    </span>
                                  </td>

                                  <td>
                                    {this.props.rights.edit && (
                                      <span
                                        class="edit cursor-hover"
                                        title="edit"
                                        onClick={() =>
                                          this.state.categoryValue === "CITY" ||
                                            this.state.categoryValue === "ADDRESS"
                                            ? this.pageChangeForCity(
                                              "edit",
                                              category._id,
                                              category.name,
                                              category.country.name,
                                              category.country._id,
                                              category
                                            )
                                            : this.pageAction(
                                              "edit",
                                              category._id,
                                              category.name,
                                              category
                                            )
                                        }
                                      >
                                        <i class="material-icons">create</i>
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {this.props.rights.delete && (
                                      <span
                                        onClick={() =>
                                          this.submit(category._id)
                                        }
                                        class="delete cursor-hover"
                                        title="delete"
                                      >
                                        <i class="material-icons">delete</i>
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              )
                            ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {this.state.componentMounted === true &&
                  this.state.categoryValue !== "DURATION" ? (
                  <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={50}
                    totalItemsCount={this.state.count}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                ) : null}
              </div>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}
const mapStateToProps = state => {
  return {
    rights: state.main.rights.system.web
  }
}

export default connect(
  mapStateToProps,
  null
)(SystemCategoryList)


// WEBPACK FOOTER //
// ./src/pages/systemCategoryList/page.js